// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 613 ? true : chunkId) + "." + {"147":"626314cb","165":"6d9be878","613":"99b5eed1"}[chunkId] + ".chunk.js";
};